export default "__VITE_ASSET__eQmAnjNs__"